import { API, ApiUrls, constructApiUrl } from '../../../api/apis.config'
import { EmailModal } from '../common/email-modal'

type Props = {
  enrollmentId: number
  isOpen: boolean
  closeModal: () => void
}

// Asked after an admin changes an enrollment: the team email is written in the popup, and the
// checkbox lets the backend also warn the parents when the stay is confirmed.
const EnrollmentModificationNotificationModal = ({ enrollmentId, isOpen, closeModal }: Props) => (
  <EmailModal
    emailApiEndpoint={
      constructApiUrl(API.enrollments.sendModificationNotification.url, {
        id: enrollmentId
      }) as ApiUrls
    }
    customCheckbox={{ label: 'Prévenir les parents' }}
    optionalContent
    label="Vous avez modifié certains champs du bulletin. Souhaitez-vous envoyer une notification ?"
    isOpen={isOpen}
    closeModal={closeModal}
    beforeSubmit={(input, checked) => ({ ...input, notifyParents: checked })}
  />
)

export default EnrollmentModificationNotificationModal
